import React from 'react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
export function FinalCTA() {
  return <section className="w-full bg-navy-deep px-4 py-16 text-white sm:py-20" data-id="element-91" data-mp="3udp26xtznyt6">
      <div className="mx-auto w-full max-w-2xl text-center" data-id="element-92" data-mp="c70yncel7jpm">
        <h2 className="font-display text-[1.65rem] font-bold leading-tight sm:text-4xl" data-id="element-93" data-mp="c4fuggqtgrop">
          La próxima paciente que entre a tu consulta no necesita que recuerdes cientos de páginas
          de guías
        </h2>

        <div className="mt-6 space-y-1.5 text-[15px] text-white/70 sm:text-lg" data-id="element-94" data-mp="h654pu67t1bq">
          <p className="font-semibold text-white" data-id="element-95" data-mp="h412dgnysadk">Necesita que tomes la decisión correcta.</p>
          <p data-id="element-96" data-mp="vwkttk1r4tf6">Y ahora tienes una Ruta Clínica diseñada exactamente para eso.</p>
        </div>

        <div className="mt-8" data-id="element-97" data-mp="qxro4dspi6pk">
          <CTAButton label="Quiero la Ruta Clínica de Menopausia™ por solo USD $27" data-id="element-98" data-mp="14v6hftm2yymt" />
        </div>

        <p className="mt-4 text-xs text-white/60 sm:text-sm" data-id="element-99" data-mp="zwvabqn6728a">
          Acceso inmediato · Pago único · Garantía de 7 días · Descarga digital de por vida ·
          Cambio de moneda automático
        </p>

        <div className="mt-8" data-id="element-100" data-mp="2h37zx4tb4x29">
          <Countdown tone="dark" data-id="element-101" data-mp="2h49kq104kxx6" />
        </div>
      </div>

      <footer className="mx-auto mt-14 w-full max-w-2xl border-t border-white/10 pt-6 text-center" data-id="element-102" data-mp="2m2b46n1gqz96">
        <p className="font-display text-sm font-bold uppercase tracking-[0.35em] text-white/70" data-id="element-103" data-mp="2r2gotj9bflhr">
          Dra. Karito
        </p>
        <p className="mt-2 text-[11px] leading-relaxed text-white/40" data-id="element-104" data-mp="2v2r5bpuqhuav">
          © {new Date().getFullYear()} Ruta Clínica de Menopausia™. Material educativo dirigido a
          profesionales de la salud. No sustituye el juicio clínico individual.
        </p>
      </footer>
    </section>;
}